import { List, Datagrid, TextField, EmailField, Filter, TextInput, DateField, DateInput } from "react-admin";
import { exporter } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";

const MessageFilter = (props) => (
  <Filter {...props}>
    <TextInput label="E-mail" source="email" alwaysOn />
    <TextInput label="Assunto" source="subject" />
    <TextInput label="Mensagem" source="text" />
    <DateInput label="Criados a partir de" source="createdAt.gte" />
    <DateInput label="Criados até" source="createdAt.lte" />
  </Filter>
);

const MessageList = (props) => (
  <List
    bulkActionButtons={<div />}
    perPage={25}
    title="Lista de Mensagens"
    exporter={exporter}
    filters={<MessageFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    actions={<CustomActions />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField sortable={false} label="Tipo de Documento" source="typeUser.name" />
      <TextField sortable={false} label="Documento" source="document" />
      <EmailField label="E-mail" source="email" />
      <TextField label="Assunto" source="subject" />
      <TextField label="Mensagem" source="text" />
      <DateField label="Data de criação" source="createdAt" />
    </Datagrid>
  </List>
);

export default MessageList;
